import { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import SubNav from "../menu/SubNav";
import Card from "../ui/Card";
import Footer from "../menu/Footer";
import CrosscheckVerificationHeader from "../verifications/crosscheck/CrosscheckVerificationHeader";
import CrosscheckService from "@/services/crosscheck";
import VerificationHeaderPlaceholder from "../placeholder/VerificationHeaderPlaceholder";
import * as Notification from "@/components/ui/Notification";
import useWebSocket from "react-use-websocket";
import AuthService from "@/services/auth";
import { CrosscheckVerificationContext } from "@/context/crosscheck_verification";
import VerificationStepPlaceholder from "../placeholder/VerificationStepPlaceholder";
import CrosscheckVisualCheck from "../verifications/crosscheck/CrosscheckVisualCheck";
import { AuthContext } from "@/context/auth";

export default function CrosscheckVerification() {
  const [, crosscheckVerificationDispatch] = useContext(
    CrosscheckVerificationContext
  );
  const [ready, setReady] = useState(false);
  const router = useHistory();
  const { session_id } = useParams();
  const [auth] = useContext(AuthContext);

  const socketUrl = `${process.env.REACT_APP_WS_HOST}/v3/websockets/online`;
  const { readyState, getWebSocket } = useWebSocket(socketUrl, {
    onOpen: async () => {},
    shouldReconnect: () => true,
  });

  useEffect(async () => {
    await getTask();
    return () => {};
  }, []);

  useEffect(async () => {
    if (readyState) {
      getWebSocket().send(
        JSON.stringify({
          auth: auth.auth.access_token,
          email: auth.user.email,
          firstname: auth.user.firstname,
          lastname: auth.user.lastname,
          profile_pic: auth.user.profile_pic,
          service: "CROSSCHECK",
          session_id: session_id,
        })
      );
    }
  }, [readyState]);

  async function getTask() {
    await CrosscheckService.GetTask(session_id)
      .then(async (data) => {
        if (data.task.service_session_id === "") {
          router.push("/verifications/crosscheck");
          return;
        }
        await crosscheckVerificationDispatch({
          type: "SET_SESSION",
          payload: data,
        });
        setReady(true);
      })
      .catch((err) => {
        Notification.error(err.message);
      });
    return () => {};
  }

  return (
    <div>
      <div>
        <SubNav></SubNav>
        <div className="max-w-7xl mx-auto relative">
          <div className="verification-container">
            {ready ? (
              <CrosscheckVerificationHeader
                onUpdate={() => getTask()}
              ></CrosscheckVerificationHeader>
            ) : (
              <VerificationHeaderPlaceholder></VerificationHeaderPlaceholder>
            )}
          </div>
        </div>
        <div className="max-w-7xl mx-auto relative">
          <div className="flex flex-wrap mt-6">
            <Card className="w-full px-3 sm:px-0">
              <div>
                <div>
                  {ready ? (
                    <div>
                      <div className="p-6">
                        <CrosscheckVisualCheck
                          onUpdate={() => getTask()}
                        ></CrosscheckVisualCheck>
                      </div>
                    </div>
                  ) : (
                    <VerificationStepPlaceholder></VerificationStepPlaceholder>
                  )}
                </div>
              </div>
            </Card>
          </div>
          <Footer></Footer>
        </div>
      </div>
    </div>
  );
}
